<ng-container *ngIf="loading">
  <div class="flex flex-column flex-grow-1 align-items-center justify-content-center full-screen-loader">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-container>
